export const getErrorMessage = (err) => {
    let errorMessage = "Një gabim ndodhi gjatë komunikimit me serverin!";

    if (err?.response?.data?.Error) {
        errorMessage = err?.response?.data?.Error;
    }

    return errorMessage;
};